module.exports = __webpack_public_path__ + "static/media/logo.173fb57b.png";